




















































































































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { i18n } from '@/i18n';
// @ts-ignore
import Card from 'card';
import { compass } from '@resclick/compass';
import { Getter, State } from 'vuex-class';
import {
  IBankAccount,
  IBankInfo,
  ICreditCardInstallment,
  IPaymentGateway,
  IPaymentGatewayInstallment,
  IProperty,
} from '@resclick/data-access';
import { CrsForm } from '@/plugins/crs-form';
import { install } from 'vuex';

@Component
export default class PaymentStep extends Vue {
  @Getter('preferences/currency') currentCurrency!: string;
  @State('cart') cart!: any;
  @Getter('cart/total') amount!: any;
  @Getter('cart/isLoading') isLoading!: boolean;
  @Getter('widget/property') property!: IProperty & {
    paymentOptionGroup: {
      bankAccounts: IBankAccount[];
      paymentGateways: IPaymentGateway[];
      banks: any;
    };
  };

  get total() {
    return this.cart.total;
  }

  orderId = window.localStorage.getItem('orderId');
  paymentModal = false;
  expiry = '';
  installmentOptions = [{ label: i18n.t('GENERAL.SINGLE_SHOT'), value: 0 }];

  bankAccounts: Array<IBankAccount & { bank: IBankInfo; id: string }> = [];
  paymentGateways: Array<IPaymentGateway> = [];

  showIntallments = false;
  loadingInstallments = false;

  foundGateway!: IPaymentGateway | undefined;

  checkedAggrements = {
    terms: false,
  };

  canCloseNow = false;

  form = this.$crsForm('payments', 'create', {
    type: 'BANK_CARD',
    method: 'VIRTUAL_POS',
    name: '',
    surname: '',
    installment: 0,
    paymentDate: new Date(),
    amount: 0,
    currency: '',
    note: '',
    cardNumber: '',
    cardExpiryMonth: '',
    cardExpiryYear: '',
    cardSecurityCode: '',
    maturityDifferencePercent: 0,
  });

  currentTemplate = '';

  @Watch('form.fields.cardNumber', { deep: true })
  async watchCardNumber(value: string) {
    if (value.length > 6 && !this.foundGateway) {
      this.loadingInstallments = true;
      const bin = value.split(' ').join('').slice(0, 6);

      const binQuery = await compass.do('payments', 'binQuery', { query: { bin } });
      const data = binQuery?.data;
      this.currentTemplate = data?.templateName;

      if (!this.currentTemplate) {
        this.currentTemplate = this.paymentGateways.find((gateway: any) => gateway.international)?.template as string;
      }

      this.foundGateway = this.property.paymentOptionGroup.paymentGateways.find(
        (p: IPaymentGateway) => p.autoSelectMap && p.autoSelectMap.includes(this.currentTemplate),
      );

      if (this.foundGateway) {
        const currentBank = this.foundGateway.multiInstallments?.find((b) => b.template === this.currentTemplate);
        const mappedInstallments = currentBank?.installments
          ?.filter((i: any) => !i.disabled)
          .map((i: IPaymentGatewayInstallment) => {
            if (i.plusInstallment) {
              return {
                value: i.numOfInstallment,
                label: `${i.numOfInstallment} + ${i.plusInstallment} ${i18n.t('GENERAL.INSTALLMENT')}`,
              };
            }
            return {
              value: i.numOfInstallment,
              label: `${i.numOfInstallment} ${i18n.t('GENERAL.INSTALLMENT')}`,
            };
          });

        this.installmentOptions = [{ label: i18n.t('GENERAL.SINGLE_SHOT'), value: 0 }].concat(
          mappedInstallments as any,
        );
      }

      if (!this.foundGateway) {
        this.foundGateway = this.property.paymentOptionGroup.paymentGateways.find(
          (p: IPaymentGateway) => p.template === this.currentTemplate,
        );

        if (!this.foundGateway) {
          this.foundGateway = this.property.paymentOptionGroup.paymentGateways[0];
        }

        const mappedInstallments = this.foundGateway?.installments
          ?.filter((i: any) => !i.disabled)
          .map((i: IPaymentGatewayInstallment) => {
            if (i.plusInstallment) {
              return {
                value: i.numOfInstallment,
                label: `${i.numOfInstallment} + ${i.plusInstallment} ${i18n.t('GENERAL.INSTALLMENT')}`,
              };
            }
            return {
              value: i.numOfInstallment,
              label: `${i.numOfInstallment} ${i18n.t('GENERAL.INSTALLMENT')}`,
            };
          });

        this.installmentOptions = [{ label: i18n.t('GENERAL.SINGLE_SHOT'), value: 0 }].concat(
          mappedInstallments as any,
        );
      }

      this.loadingInstallments = false;
    } else {
      this.foundGateway = undefined;
    }
  }

  @Watch('expiry')
  onChangeExpiry(value: string) {
    this.calculateMonthAndYear(value);
  }

  @Watch('form.fields.type')
  onPaymentTypeChange() {
    const el = document.querySelector('.jp-card-container');
    if (this.form.fields.type === 'BANK_TRANSFER') {
      if (el) {
        (el as any).style.display = 'none';
      }
    } else {
      (el as any).style.display = 'block';
    }
  }

  bankName(bankCode: number) {
    const bank = this.property.paymentOptionGroup.banks.find((b: any) => b.bankCode === bankCode);
    if (bank) {
      return bank.bankName;
    }
    return '';
  }

  calculateMonthAndYear(value: string) {
    const str = value.split('/');

    this.form.fields.cardExpiryMonth = str[0];
    this.form.fields.cardExpiryYear = '20' + str[1];
  }

  get agreementOptions() {
    return [];
  }

  get paymentTypeOptions() {
    return [
      { label: i18n.t('GENERAL.CREDIT_CARD'), value: 'BANK_CARD' },
      { label: i18n.t('GENERAL.BANK_TRANSFER'), value: 'BANK_TRANSFER' },
    ];
  }

  calculateAmount(saleRate: number): string {
    if (saleRate === 0) {
      return this.amount.value.toFixed(2);
    }

    const i = this.amount.value / 100;
    const plus = i * saleRate;
    return (this.amount.value + plus).toFixed(2);
  }

  calculateInstallment(installment: number, calculatedAmount: string): string {
    return (parseFloat(calculatedAmount) / installment).toFixed(2);
  }

  expiryError() {
    return !!(this.expiry === '');
  }

  mapBankAccounts() {
    const bankAccounts = this.property.paymentOptionGroup.bankAccounts;
    const banks = this.property.paymentOptionGroup.banks;

    // @ts-ignore
    this.bankAccounts = bankAccounts.map((account: IBankAccount) => {
      const bank = banks.find((b: IBankInfo) => b.bankCode === account.bankCode);
      return {
        ...account,
        bank,
      };
    });
  }

  findCardLogo(cardName: string) {
    cardName = cardName.toLowerCase();

    if (cardName.includes('advantage')) {
      return require('../../assets/card-logos/advantage.png');
    } else if (cardName.includes('axess')) {
      return require('../../assets/card-logos/axess.png');
    } else if (cardName.includes('bonus')) {
      return require('../../assets/card-logos/bonus.png');
    } else if (cardName.includes('cardfinans')) {
      return require('../../assets/card-logos/cardfinans.png');
    } else if (cardName.includes('maximum')) {
      return require('../../assets/card-logos/maximum.png');
    } else if (cardName.includes('paraf')) {
      return require('../../assets/card-logos/paraf.png');
    } else if (cardName.includes('world')) {
      return require('../../assets/card-logos/world.png');
    }
  }

  mapInstallments() {
    const paymentGateways = this.property.paymentOptionGroup.paymentGateways;
    const biggestValues = paymentGateways
      .map((gateway: IPaymentGateway) => gateway.installments || [])
      .map((installments: IPaymentGatewayInstallment[]) => {
        const values = installments.map((installment: IPaymentGatewayInstallment) => installment.numOfInstallment);
        return Math.max(...values);
      });
    const biggest = Math.max(...biggestValues);

    // for (let i = 2; i <= biggest; i++) {
    //   this.installmentOptions.push({ value: i, label: `${i} ${i18n.t('GENERAL.INSTALLMENT')}` });
    // }

    this.paymentGateways = paymentGateways.map((gateway: IPaymentGateway) => {
      let installments = gateway.installments;

      if (installments && installments.length) {
        for (let i = 1; i <= biggest; i++) {
          const index = installments.findIndex((inst: IPaymentGatewayInstallment) => i === inst.numOfInstallment);

          if (index < 0) {
            installments.push({
              numOfInstallment: i,
              days: 0,
              purchasePercent: 0,
              salePercent: 0,
              plusInstallment: 0,
              // @ts-ignore
              disabled: true,
            });
          }
        }

        installments = installments.sort(
          (inst1: IPaymentGatewayInstallment, inst2: IPaymentGatewayInstallment) =>
            inst1.numOfInstallment - inst2.numOfInstallment,
        );
      }

      return { ...gateway, installments };
    });

    this.paymentGateways = this.paymentGateways.filter((value: IPaymentGateway, i: number, self: IPaymentGateway[]) => {
      const index = self.findIndex((val: IPaymentGateway) => value.name === val.name);
      return index === i;
    });
  }

  mounted() {
    this.form.fields.amount = this.amount.value || 0;
    this.mapBankAccounts();
    this.mapInstallments();

    new Card({
      form: 'form',
      container: '#card-wrapper',
      formSelectors: {
        nameInput: 'input[name="name"], input[name="surname"]',
        numberInput: 'input[name="cardNumber"]',
        expiryInput: 'input[name="expiry"]',
        cvcInput: 'input[name="cvc"]',
      },
    });
  }

  toggleInstallmentsTable() {
    this.showIntallments = !this.showIntallments;
  }

  async getOrder() {
    return compass.do('orders', 'findOne', {
      params: {
        orderId: this.orderId,
      },
      query: {
        currency: this.currentCurrency,
      },
    });
  }

  /*
  calculateTotal(products: IProductType[]) {
    // @ts-ignore
    const productsAmounts = products.map((p) => p.price.exchangedPrice.value);
    const total = productsAmounts.reduce((a, b) => a + b, 0);

    return total;
  }
  */

  get installmentsTable() {
    const installments: any[] = [];

    for (const gateway of this.paymentGateways) {
      if (
        gateway.installments?.length &&
        !this.paymentGateways.some((g) => g.autoSelectMap?.includes(gateway.template))
      ) {
        installments.push({
          gateway,
          name: gateway.name,
          installments: gateway.installments,
        });
      } else if (['FASTPAY', 'IYZICO'].includes(gateway.template) && gateway.multiInstallments?.length) {
        for (const installment of gateway.multiInstallments) {
          const template = installment.template;
          let name: string = installment.template.toLocaleLowerCase('tr-TR').toLocaleUpperCase('tr-TR') || '';
          switch (template) {
            case 'FINANS':
              name = 'Cardfinans';
              break;
            case 'HALKBANK':
              name = 'Paraf';
              break;
            case 'ISBANK':
              name = 'Maximum';
              break;
            case 'AKBANK':
              name = 'Axess';
              break;
            case 'HSBC':
              name = 'Advantage';
              break;
            case 'GARANTI':
              name = 'Garanti Bonus';
              break;
            case 'YAPIKREDI':
              name = 'World';
              break;
          }
          if (gateway.autoSelectMap?.includes(installment.template)) {
            installments.push({
              name: name,
              installments: installment.installments,
            });
          }
        }
      }
    }

    return installments;
  }

  async submit() {
    this.form.fields.amount = this.amount.value;

    let installments: any = [];
    if (['FASTPAY', 'IYZICO'].includes(this.foundGateway?.template || '')) {
      installments = this.foundGateway?.multiInstallments?.find((i: any) => i.template === this.currentTemplate)
        ?.installments;
    } else {
      installments = this.foundGateway?.installments;
    }

    if (this.form.fields.installment && this.form.fields.installment > 1) {
      const installment = installments.find(
        (i: IPaymentGatewayInstallment) => i.numOfInstallment === this.form.fields.installment,
      );

      this.form.fields.maturityDifferencePercent = installment?.salePercent;
    } else {
      this.form.fields.installment = 0;
    }

    this.form.fields.currency = this.currentCurrency;
    this.form.fields.cardNumber = this.form.fields?.cardNumber?.split(' ').join('');
    this.form.fields.paymentGateway = (this.foundGateway as any).id;

    this.form
      .submit({
        params: { orderId: this.orderId },
      })
      .then((res) => {
        this.paymentModal = true;
        setTimeout(() => {
          let iframe = document.getElementById('3d-iframe') as HTMLIFrameElement;

          iframe.srcdoc = res.data as any;
        }, 100);
        this.$emit('update-data');
        this.canCloseNow = true;
      });
  }
}
